import { KeyGetter, ItemValue } from './types'
import { getKey } from './utils'
import { ItemsMap } from './items'

/**
 * Prepares options for further usage.
 *
 * **Example:**
 * ```js
 * import { makeOptions } from '@aspectus/selection-controller'
 *
 * const items = [
 *   { key: 1, value: { id: 1, title: 'First' } },
 *   { key: 2, value: { id: 2, title: 'Second' } },
 *   { key: 3, value: { id: 3, title: 'Third' } },
 * ]
 * const options = makeOptions(items)
 *
 * // You may iterate using `options.items` because
 * // they are equals to items.
 * // And to get a specific one fast you may use `.get` method:
 * console.log(options.get(2))
 * // > { key: 2, value: { id: 2, title: 'Second' } }
 * ```
 *
 * @category General
 * @export
 * @param keyGetter - Option key resolving function.
 * @param options - List of option values.
 * @returns Options ItemsMap.
 */
export function makeOptions<T = ItemValue>(
  keyGetter: KeyGetter<T>,
  options: T[]
): ItemsMap<T> {
  return new ItemsMap<T>(
    options.map(value => ({ value, key: getKey(keyGetter, value) }))
  )
}
